import { type FC } from 'react'
import { Button } from '../../../components/Button/Button'
import { SchedulingStatusCard } from '../SchedulingStatusCard'

// Every tab needs its own error state: only a tab's first-page query is covered by
// useSchedulingPageStatus's page-level error card — a failure after the user paginates or
// changes page size would otherwise render as the tab's empty state.
export const SchedulingTabErrorCard: FC<{ title: string; onRetry: () => void }> = ({ title, onRetry }) => (
  <SchedulingStatusCard
    icon={<i className='bi bi-exclamation-triangle-fill text-danger' aria-hidden='true' />}
    title={title}
    subtitle='Something went wrong on our end. Refresh to try again.'
  >
    <Button variant='primary' onClick={onRetry}>
      Refresh
    </Button>
  </SchedulingStatusCard>
)
